const Admin = () => import(/* webpackChunkName: "admin" */ '../views/admin/Admin')

const ADMIN_ROLE = 'admin'

export default [

  // ---------- ADMIN ----------
  {
    path: '/:tenant/admin',
    name: 'admin',
    component: Admin,
    meta: {
      title: 'app.admin',
      icon: 'mdi-cogs',
      tenant: true,
      admin: true,
      role: ADMIN_ROLE
    }
  },

  // ---------- Organisation ----------
  {
    path: '/:tenant/admin/org',
    name: 'admin-org',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/OrganizationView.vue'),
    meta: {
      title: 'Inställningar',
      icon: 'mdi-cogs',
      tenant: true,
      admin: true,
      role: ADMIN_ROLE,
      organization: true
    }
  },
  {
    path: '/:tenant/init',
    name: 'tenant-create',
    component: () => import(/* webpackChunkName: "home" */ '../views/settings/CreateTenantView'),
    meta: {
      title: 'Skapa ny organisation',
      icon: '$company',
      tenant: true,
      permission: 'tenant:create',
      admin: false, // DISABLED
      organization: true
    }
  },
  {
    path: '/:tenant/admin/users',
    name: 'admin-users',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/OrganizationUsers.vue'),
    meta: {
      title: 'Användare',
      icon: '$user',
      tenant: true,
      admin: true,
      role: ADMIN_ROLE,
      organization: true
    }
  },
  {
    path: '/:tenant/admin/users/:id',
    name: 'edit-user-account',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/UserAdminView.vue'),
    props: true,
    meta: {
      title: 'Användare',
      icon: '$user',
      tenant: true,
      role: ADMIN_ROLE
    }
  },
  {
    path: '/:tenant/admin/roles',
    name: 'admin-org-roles',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/UserRoleAdminView.vue'),
    meta: {
      title: 'Användarroller',
      icon: 'mdi-account-box',
      tenant: true,
      admin: true,
      role: ADMIN_ROLE,
      organization: true
    }
  },
  {
    path: '/:tenant/admin/groups',
    name: 'admin-groups',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/OrganizationGroups.vue'),
    meta: {
      title: 'Grupper',
      icon: '$group',
      tenant: true,
      admin: true,
      role: ADMIN_ROLE,
      organization: true
    }
  },
  {
    path: '/:tenant/admin/migration',
    name: 'migration',
    component: () => import(/* webpackChunkName: "migration" */ '../views/admin/Migration.vue'),
    meta: {
      title: 'Migrera data',
      icon: 'mdi-database-import-outline',
      tenant: true,
      admin: true,
      role: ADMIN_ROLE,
      feature: 'migrate',
      organization: true
    }
  },

  // ---------- Övrigt ----------
  {
    path: '/:tenant/admin/templates/export',
    name: 'document-templates',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/DocumentTemplateView'),
    meta: {
      title: 'Utskriftsmallar',
      icon: 'mdi-text-box-multiple',
      tenant: true,
      admin: true,
      role: ADMIN_ROLE,
      misc: true
    }
  },
  {
    path: '/:tenant/admin/templates/export/:id',
    name: 'document-template-edit',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/DocumentTemplateAdmin'),
    meta: {
      title: 'Redigera dokumentmall',
      icon: 'mdi-file-document-box',
      tenant: true,
      admin: true,
      role: ADMIN_ROLE
    }
  },
  {
    path: '/:tenant/admin/templates/email',
    name: 'email-templates',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/EmailTemplateView'),
    meta: {
      title: 'E-postmallar',
      icon: '$email',
      tenant: true,
      admin: true,
      misc: true,
      role: ADMIN_ROLE
    }
  },
  {
    path: '/:tenant/admin/templates/email/:id',
    name: 'email-template-edit',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/EmailTemplateAdmin'),
    meta: {
      title: 'Redigera e-postmall',
      icon: '$email',
      tenant: true,
      admin: true,
      role: ADMIN_ROLE
    }
  },
  {
    path: '/:tenant/admin/form',
    name: 'form-admin-list',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/form/FormAdminList'),
    meta: {
      title: 'Formulär och attribut',
      icon: 'mdi-form-select',
      tenant: true,
      admin: true,
      misc: true
    }
  },
  {
    path: '/:tenant/admin/form/:id',
    name: 'form-admin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/form/FormAdminView'),
    props: true,
    meta: {
      title: 'Formulär',
      icon: 'mdi-form-select',
      tenant: true,
      admin: true,
    }
  },
  {
    path: '/:tenant/admin/sequences',
    name: 'sequences',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/SequenceNumberListView'),
    meta: {
      title: 'Nummerserier',
      icon: '$sequence',
      tenant: true,
      admin: false, // DISABLED
      role: ADMIN_ROLE,
      misc: true
    }
  },
  // Fortnox Integration
  {
    path: '/:tenant/admin/fortnox',
    name: 'fortnox',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/invoice/FortnoxConfigurationView'),
    props: route => ({ code: route.query.code, state: route.query.state }),
    meta: {
      title: 'Fortnox integration',
      icon: 'mdi-invoice-text-clock-outline',
      tenant: true,
      admin: false, /* This must be false, otherwise Fortnox activation will fail. :-( */
      misc: true,
      feature: 'invoice'
    }
  },
  {
    path: '/fortnox/activation',
    name: 'fortnox-activation-entrypoint',
    redirect: to => {
      return { name: 'fortnox', query: to.query, params: { tenant: to.query.state }}
    },
  },
  {
    path: '/:tenant/admin/system-check',
    name: 'system-check',
    component: () => import(/* webpackChunkName: "admin" */ '../views/admin/MetadataCheck'),
    meta: {
      title: 'Systemkontroll',
      icon: 'mdi-cogs',
      tenant: true,
      admin: true,
      role: ADMIN_ROLE,
      misc: true
    }
  },
]
